import React from 'react';
import { withRouter } from 'react-router-dom';

import FieldModal from '../../../../components/modals/fieldModal';

class DeleteSubmissionModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleting: false,
        }
    }

    deleteSubmission = () => {
        const { isDeleting } = this.state;
        this.setState({ isDeleting: true });
        this.props.deleteSubmission(() => {
            this.setState({ isDeleting: false });
            this.props.toggle();
        })
    }

    render() {
        const { isOpen, toggle, selectedSubmissionCount } = this.props;
        const { isDeleting } = this.state;
        let isMultiple = selectedSubmissionCount > 1;
        return (
            <div>

                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Delete Selected Submission" + (isMultiple ? 's' : '')}
                    bodyHeaderText={''}
                    bodyContent={() => {
                        return ('Are you sure you want to delete the selected submission' + (isMultiple ? 's' : '') + '?');
                    }}
                    toggle={toggle}
                    actionButtonLabel={!isDeleting ? 'Delete' : 'Deleting...'}
                    actionButton={this.deleteSubmission}

                    actionButtonDisabled={isDeleting}
                    isDelete={true}
                ></FieldModal>

            </div >
        );
    }
}

export default withRouter(DeleteSubmissionModal);
